require('../../modules/es.string.trim-start');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'trimLeft');
